module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-12.a822ea21.jpg";